<template>
  <div class="user-message-wraper">
    <van-nav-bar 
      title="我的消息" 
      left-arrow 
      @click-left="$router.go(-1)"
      @click-right="readAll"
    >
      <template #right>
        <span class="all-read">全部已读</span>
      </template>
    </van-nav-bar>
    <!-- 搜索 -->
    <van-search v-model="value" shape="round" placeholder="请输入关键字" @search="onSearch"/>
    <!-- <div style="height:300px">xx</div> -->
    <!-- 消息列表 -->
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      v-if="messageList.length"
    >
      <ul class="user-message-list">
        <li class="user-message-item"
          v-for="(item, index) in messageList"
          :key="index"
          @click="toDetail(item)"
        >
          <div class="title-btn">
            <span class="title-name-wraper">
              <span :class="item.readStatus?'':'dot'"></span>
              <span class="title-name ellipsis">
                {{item.msgTitle}}
              </span>
            </span>
            <span class="del-btn" @click.stop="deleteItem(item)">删除</span>
          </div>
          <p class="msg-content two-ellipsis">
            {{item.msgContent}}
          </p>
        </li>
      </ul>
    </van-list>
    <!-- 无数据情况 -->
    <div class="no-search" v-else>
        <img src="../../../assets/images/userMessage/nolist.png"/>
        <div>暂无消息</div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  export default {
    name: 'messageList',
    data() {
      return {
        value: '',
        loading: false,
        finished: false,
        messageList: [],
        pageNum: 0
      }
    },
    mounted() {
      this.onLoad()
    },
    methods: {
      onSearch() {
        this.pageNum = 1
        this.getList()
      },
      onLoad() {
        this.pageNum = this.pageNum*1 + 1
        this.loading = true
        this.getList()
      },
      //获取所有列表
      async getList() {
        let params = {
          pageNum: this.pageNum,
          pageSize: 20
        }
        let data = {
          keyword: this.value,
          readStatus: null
        }
        let result = await this.$api.userMessage.getList({params, data})
        if(result.success) {
          // 
          if(this.pageNum === 1) {
            this.messageList = result.data.list

          } else {
            this.messageList = [...this.messageList, ...result.data.list]
          }
          this.finished = result.data.isLastPage
          this.loading = false
        }
      },
      // 全部已读
      async readAll() {
        if(!this.messageList.length) {
          this.$toast('暂无消息可读')
        }
        let result = await this.$api.userMessage.readAll()
        if(result.success) {
          this.getList()
        }
      },
      async deleteItem(item) {
        let result = await this.$api.userMessage.delete({id:item.id})
        if(result.success) {
          this.$toast('删除成功')
          this.getList()
        }
      },
      toDetail(item) {
        this.$router.push({
          name: 'userMessageDetail',
          path: '/userMessageDetail',
          query: {
            id: item.id,
            status: item.readStatus
          }
        })
      }
    }
  
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.ellipsis
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
.two-ellipsis
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
.user-message-wraper
  width 100%
  min-height 100%
  background-color #F9F9F9
  .all-read 
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3760FF;
    line-height: 28px
  .user-message-list
    width 100%
    box-sizing border-box
    padding 0 30px
    .user-message-item
      background-color #fff
      margin-top 20px
      border-radius 16px
      padding 28px 30px
      .title-btn 
        display flex 
        justify-content space-between
        align-items center
        .title-name-wraper
          flex 1
          font-size: 34px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 34px
          display flex 
          align-items center
          .title-name
            flex 1
            max-width 530px
            word-wrap: break-word
          .dot 
            width: 12px;
            height: 12px;
            background: #FF4C4C
            border-radius 50%
            margin-right 16px
        .del-btn 
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #3760FF;
          line-height: 26px; 
          padding-left 16px
      .msg-content
        margin-top 18px
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 40px
        word-wrap: break-word
  .no-search
    margin-top 26%
    margin-bottom 300px
    display flex 
    flex-direction column
    justify-content center 
    align-items center
    img 
      width 300px
      height 191px
    div
      color: #999999;
      font-size: 0.906rem;
      font-weight: 400;
      margin-top: 0.693rem;
      font-family: PingFangSC-Regular, PingFang SC;
 
</style>
